import { Booking } from 'swagger/models';

// A function that determines whether a booking is pre-approvable
export const isPreApprovable = (booking: Booking) =>
  canPreApproveAndGrandfathered(booking) && canPreApproveIfReadyForRental(booking);

export const canPreApproveAndGrandfathered = (booking: Booking) =>
  booking.can_pre_approve && booking.ready_for_rental_post_grandfathering;

export const canPreApproveIfReadyForRental = (booking: Booking) => booking.could_pre_approve_if_ready_for_rental;
